/* eslint-disable */
require('./arrow_down')
require('./arrow_left')
require('./arrow_right')
require('./arrow_up')
require('./available')
require('./bell')
require('./box')
require('./bulb')
require('./calendar')
require('./clip')
require('./close')
require('./contacts')
require('./crop')
require('./damage')
require('./dollar')
require('./double_arrow_right')
require('./ecg')
require('./fit')
require('./gallery')
require('./geofence')
require('./help')
require('./history')
require('./inbox')
require('./magnify')
require('./menu')
require('./message_warning')
require('./pin')
require('./plus')
require('./previous')
require('./question')
require('./route')
require('./sales')
require('./settings')
require('./star')
require('./support')
require('./tracking')
require('./trash')
require('./truck')
require('./unavailable')
require('./upload')
require('./user')
require('./warehouse')
require('./warning')
